import { Base } from '@studiometa/js-toolkit';
import { Menu, Panel, Action, Accordion, DataModel, DataEffect } from '@studiometa/ui';
import Frame from '../Frame/index.js';
import { nextTick } from '@studiometa/js-toolkit/utils';
import PriceRange from '../PriceRange/index.js'


/**
 * Facets component
 */
export default class Facets extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Facets',
    refs: ['directinput','loadmore', 'container', 'products[]', 'counter'],
    components: {
      Frame,
      Action,
      Menu,
      Panel,
      PanelAccordion: Accordion,
      DataModel,
      DataEffect,
      PriceRange
    },
  };

  /**
   * Get total products in listing
   * @returns {void}
   */
  get totalProducts() {
    return document.querySelectorAll('.product-item').length;
  }

  /**
   * form
   * @returns {HTMLFormElement}
   */
  get form() {
    return this.$el.querySelector('form');
  }

  /**
   * onDirectinputChange
   */
  onDirectinputChange() {
    const event = new Event('submit', { bubbles: true, cancelable: false });
    this.form.dispatchEvent(event);
  }

  /**
   * Click on loadmore
   * @param {object} props Props
   * @param {object} props.target current element
   * @returns {void}
   */
  onLoadmoreClick({ target }) {
    const url = target.dataset.href;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const results = html.querySelector(`[data-ref="Facets.container"]`);

        this.hideNewProducts(results);

        nextTick(() => {
          this.$refs.container.innerHTML += results.innerHTML;
        });

        const newLoadmore = html.querySelector(`[data-ref="Facets.loadmore"]`);
        if (newLoadmore) {
          this.$refs.loadmore.dataset.href = newLoadmore.dataset.href;
        } else {
          this.$refs.loadmore.style.display = 'none';
        }

        this.$update();

        nextTick(() => {
          setTimeout(() => {
            this.showNewProducts();
          }, 100);

          this.$refs.counter.innerHTML = this.totalProducts;
        });
      });
  }

  /**
   * [hideNewProducts description]
   * @param  {object} results element.
   * @returns {void}
   */
  hideNewProducts(results) {
    results.querySelectorAll('[data-ref="Facets.products[]"]').forEach((element, index) => {
      element.style.transitionDelay = `${index * 50}ms`;
      element.classList.add('transition', 'duration-1000', 'opacity-0', 'blur-sm');
    });
  }

  /**
   * Change class to new products to display them
   * @returns {void}
   */
  showNewProducts() {
    document.querySelectorAll('.product-item').forEach((element) => {
      element.classList.remove('opacity-0', 'blur-sm');
    });
  }
}
